/* eslint-disable @typescript-eslint/no-shadow */
/** コード値と表示名の組み合わせを表す共通型。 */
export type CodeAndName = {
  code: string;
  name: string;
  nameShort?: string;
};

/** アプリ全体で使う API パス定義。 */
export namespace ApiUrl {
  export const DOMAIN = process.env.NEXT_PUBLIC_BFF_URL;

  /** 認証API */
  export namespace Authn {
    /** マイページログイン */
    export const LOGIN_V2 = '/api/v2/authn/mypage/login';
    /** ログイン履歴情報取得 */
    export const LOGIN_HISTORY_INFO = '/api/authn/mypage/login-history';
    /** マイページログアウト */
    export const LOGOUT = '/api/authn/logout';
    /** クレデンシャル更新 */
    export const RENEW = '/api/authn/renew';
  }

  /** 非認証API */
  export namespace NonProtected {
    /** ワンタイムパスワード発行 */
    export const ONETIME_PASSWORD = '/api/v1/password-reset/otp';
    /** ワンタイムパスワード検証 */
    export const VALIDATE_ONETIME_PASSWORD = '/api/v1/password-reset/otp/verification';
    /** パスワードリセット */
    export const PASSWORD_RESETTING = '/api/v1/password-reset';
    /** ワンタイムパスワード発行 */
    export const ONETIME_PASSWORD_V2 = '/api/v2/password-reset/otp';
    /** パスワードリセット */
    export const PASSWORD_RESETTING_V2 = '/api/v2/password-reset';
  }
  /** 参照系API */
  export namespace Read {
    /** ユーザー情報取得 */
    export const USER_INFO = '/api/read/v1/user';
    /** 初回ログインチェック */
    export const CHECK_FIRST_LOGIN = '/api/read/v1/user/check-first-login';
    /** 契約者情報取得 */
    export const CONTRACT_INFO = '/api/read/v1/contract';

    /** 契約プラン情報取得 */
    export const PLAN_INFO = '/api/read/v1/contract/plan';

    /** プロモーション情報取得 */
    export const PROMOTION_INFO = '/api/read/v1/promotion';

    /** キャンペーン情報取得 */
    export const CAMPAIGN_INFO = '/api/read/v1/campaign';
    /** キャッシュバック情報取得 */
    export const CASHBACK_INFO = '/api/read/v1/cashback';
    /** 請求情報取得 */
    export const BILLING_INFO = '/api/read/v1/billing';

    /** 請求情報取得 */
    export const BILLING_INFO_INVOICE = '/api/read/v1/billing_invoice';
    /** 支払情報取得 */
    export const PAYMENT_INFO = '/api/read/v1/payment';

    /** 工事費残債情報取得 */
    export const CONSTRUCTION_INFO = '/api/read/v1/installment/construction-cost';
    /** オプション情報取得 */
    export const OPTIONS_INFO = '/api/read/v1/option';
    /** オプション詳細取得(amuelink) */
    export const AMUELINK = '/api/read/v1/option/amuelink';
    /** オプション詳細取得(NURO でんき) */
    export const NURO_DENKI = '/api/read/v1/option/nurodenki';
    /** オプション詳細取得(NURO SAFE) */
    export const NURO_SAFE = '/api/read/v1/option/nurosafe';
    /** オプション詳細取得(McAfee) */
    export const MCAFEE_INFO = '/api/read/v1/option/mcafee';
    /** オプション詳細取得(kaspersky) */
    export const KASPERSKY = '/api/read/v1/option/kaspersky';
    /** オプション詳細取得(sumainokaketsuke) */
    export const SUMAINO_KAKETSUKE = '/api/read/v1/option/sumainokaketsuke';
    /** オプション詳細取得(kurashinokenko) */
    export const KURASHINO_KENKO = '/api/read/v1/option/kurashinokenko';
    /** オプション詳細取得(smartlife) */
    export const NURO_SMART_LIFE = '/api/read/v1/option/smartlife';
    /** オプション詳細取得(ps5) */
    export const PS5 = '/api/read/v1/option/ps5';
    /** オプション詳細取得(Seiton&Hozon) */
    export const SEITON_HOZON = '/api/read/v1/option/seiton-hozon';
    /** スマートホームサービス更新月 */
    export const SMARTHOME = '/api/read/v1/option/smarthome';
    /** オプション詳細取得(らくらくバックアップ無制限) */
    export const RAKURAKU_BACKUP = '/api/read/v1/option/rakurakubackup';
    /** オプション詳細取得(超ホーダイ) */
    export const CHO_HODAI = '/api/read/v1/option/chohodai';
    /** オプション詳細取得(TokutokuDelikitch) */
    export const TOKUTOKU_DELIKITCH = '/api/read/v1/option/tokutokudelikitch';
    /** オプション詳細取得(OsaifuSupport) */
    export const OSAIFU_SUPPORT = '/api/read/v1/option/osaifusupport';
    /** オプション詳細取得(BRAVIA) */
    export const BRAVIA = '/api/read/v1/option/bravia';
    /** VoIPオプション利用料金取得 */
    export const VOIP_OPTION_PRICE = '/api/read/v1/option/voip/price';
    /** VoIP申込可否判定 */
    export const VOIP_OPTION_SUBSCRIPTION_CHECK = '/api/read/v1/option/voip/check';
    /** お知らせ情報取得 */
    export const NOTIFICATION_INFO = '/api/read/v1/notification';

    /** 請求書ダウンロード */
    export const DOWNLOAD_INVOICE = '/api/read/v1/download/invoice';
    /** 請求書ダウンロード（インボイス制度対応） */
    export const DOWNLOAD_INVOICE_PDF = '/api/read/v1/download/invoice_pdf';
    /** 割賦総額ダウンロード */
    export const DOWNLOAD_INSTALLMENT = '/api/read/v1/download/installment';
    /** 契約書面ダウンロード */
    export const DOWNLOAD_CONTRACT = '/api/read/v1/download/contract';
    /** 工事承諾情報取得 */
    export const CONSTRUCTION_AGREEMENT_INFO = '/api/read/v1/construction-agreement';
    /** 紹介者トークン情報取得 */
    export const INTRODUCE_INFO = '/api/read/v1/introduce';
    /** お客様専用 紹介用URL情報取得 */
    export const INTRODUCE_CAMPAIGN_INFO = '/api/read/v1/mansion/introduce';
    /** 移転トークン情報 */
    export const MOVE_TOKEN_INFO = '/api/read/v1/moveToken';
    /** So-net メール情報 */
    export const SONET_MAIL_INFO = '/api/read/v1/sonetMail';
    /** SMBC口座振替登録情報取得 */
    export const KOUFURI_INFO = '/api/read/v1/koufuri';
    /** Hands-up設備導入残債情報取得 */
    export const HANDSUP_INFO = '/api/read/v1/hands-up/facility-cost';
    /** 任意団体活動報告書一覧取得 */
    export const PRIVATE_ORGANIZATION_INFO_REPORT_LIST =
      '/api/read/v1/private-organization-info/report-list';
    /** 任意団体活動報告書詳細取得 */
    export const PO_REPORT_DETAIL = '/api/read/v1/private-organization-info/report-detail';
    /** 工事予約URLトークン取得 */
    export const CONSTRUCTION_ENTRY_INFO = '/api/read/v1/construction-entry';
    /** 開通工事の進捗取得 */
    export const CONSTRUCTION_PROGRESS_INFO = '/api/read/v1/construction-progress';
    /** 解約キャンセル情報取得 */
    export const QUIT_CANCEL_INFO = '/api/read/v1/quit-cancel';
    /** チャットボットキー取得 */
    export const CHATBOT_KEY = '/api/read/v1/customer-key';
    /** 警告情報取得 */
    export const CAUTION_INFO = '/api/read/v1/caution';
    /** 楽天VoIP通話明細取得 */
    export const RVOIP_VOICE_INFO = '/api/read/v1/voice';
    /** 楽天Voip通話明細ダウンロード */
    export const DOWNLOAD_VOICE = '/api/read/v1/download/voice';
    /** 配送情報取得 */
    export const DELIVERY_INFO = '/api/read/v1/delivery';
    /** 請求先住所情報取得 */
    export const BILLING_ADDRESS_INFO = '/api/read/v1/billing-address-info';
    /** 設置先住所情報取得 */
    export const INSTALLATION_ADDRESS_INFO = '/api/read/v1/installation-address-info';
    /** 解約時の契約解除料・工事費残債取得 */
    export const CANCELLATION_FEE = '/api/read/v1/cancellation-fee';
    /** Sonyアカウント情報取得 */
    export const SONY_ACCOUNT_INFO = '/api/read/v1/sony-account';
    /** Sonyアカウント情報のトークン取得 */
    export const SONY_ACCOUNT_INFO_TOKEN = '/api/read/v1/sony-account/token';
    /** 書面投函日情報取得 */
    export const DOCUMENTS_POSTING_INFO = '/api/read/v1/document-shipping';
    /** 通知履歴取得 */
    export const NOTIFICATION_HISTORY = '/api/read/v1/notification-history';
    /** プレゼントキャンペーン情報取得 */
    export const PRESENT_CAMPAIGN_INFO = '/api/read/v1/campaign/present-info';
    /** サービス提供判定取得 */
    export const UPGRADE_AREA_CHECK = '/api/read/v1/g10upgAreaJudge';
    /** アップグレード可否判定取得 */
    export const UPGRADE_ACCEPTANCE_JUDGEMENT = '/api/read/v1/g10upgEnableJudge';
    /** 10Gアップグレード紐づけSTS取得 */
    export const UPGRADE_STS = '/api/read/v1/g10upgStateInfo';
    /** 10Gアップグレード受付判定 */
    export const UPGRADE_RESULT = '/api/read/v1/g10upgAcceptJudge';
    /** 10Gアップグレードトークン情報取得 */
    export const UPGRADE_TOKEN = '/api/read/v1/g10upgTokenInfo';
    /** 10Gアップグレード受付判定（マンション用） */
    export const UPGRADE_RESULT_FOR_MANSION = '/api/read/v1/g10UpgradeAcceptJudgeMansion';
    /** 返還一覧取得 */
    export const BILLING_RLS_REFUND_LIST = '/api/read/v1/billing-rls-refund-list';
    /** 返還明細(PDF) */
    export const DOWNLOAD_REFUND = '/api/read/v1/download/refund';

    /** 支払情報取得 */
    export const PAYMENT_V2 = '/api/read/v2/services/:service_id/payment';

    /** 契約者情報取得 */
    export const CONTRACT_V2 = '/api/read/v2/services/:service_id/contract';
    /** 契約サービス情報取得 */
    export const SERVICE = '/api/read/v1/service';
    /** 利用料金明細取得 */
    export const BILLING_INFO_V2 = '/api/read/v2/services/:service_id/billing';
    /** 利用料金明細取得 */
    export const BILLING_INFO_BY_MONTH_V2 =
      '/api/read/v2/services/:service_id/billing/:target_month';
    /** 繰越請求情報取得 */
    export const CARRIED_FORWARD_BILLING_BY_MONTH =
      '/api/read/v1/services/:service_id/carried-forward-billing/:target_month';
    /** 請求書ダウンロード（インボイス制度対応） */
    export const DOWNLOAD_INVOICE_V2 =
      '/api/read/v2/services/:service_id/download/invoice_pdf/:target_month/:sub_system_id';
    /** 請求書明細取得 */
    export const BILLING_INVOICE_V2 =
      '/api/read/v2/services/:service_id/billing_invoice/:target_month';

    /** プロモーション情報取得 */
    export const PROMOTION_V2 = '/api/read/v2/services/:service_id/contract/promotion';
    /** 契約者情報取得V2  */
    export const CONTRACT_INFO_V2 = '/api/read/v2/services/:service_id/contract';
    /** お知らせ情報取得V2 */
    export const NOTIFICATION_INFO_V2 = '/api/read/v2/services/:service_id/notification';
    /** 通知履歴取得V2 */
    export const NOTIFICATION_HISTORY_V2 = '/api/read/v2/services/:service_id/notification-history';
    /** ログインメッセージ取得 */
    export const LOGIN_MESSAGE = '/api/read/v1/services/:service_id/login-message';
    /** 機器配送回収情報取得 */
    export const DEVICE_DELI_COLL_INFO = '/api/read/v1/services/:service_id/device-deli-coll-info';
    /** ひかりTV詳細情報取得 */
    export const HIKARI_TV_INFO = '/api/read/v1/services/:service_id/option/hikaritv';
    /** 光回線再利用情報取得 */
    export const LINE_REUSE_INFO = '/api/read/v1/line_reuse_info';
    /** 手続き履歴情報取得 */
    export const PROCEDURE = '/api/read/v1/services/:service_id/contract/procedure';

    /** サービス情報 */
    export namespace Services {
      /** 支払情報 */
      export namespace Payment {
        /** 支払情報：規制情報（オプション） */
        export const RESTRICTION_OPTION =
          '/api/read/v1/services/:service_id/payment/restriction/option';
        /** 支払情報：規制情報（口座振替） */
        export const RESTRICTION_JUDGEACCOUNTTRANSFER =
          '/api/read/v1/services/:service_id/payment/restriction/judgeAccountTransfer';
      }
      /** オプション情報 */
      export namespace Option {
        /** PS5オプション：在庫情報取得 */
        export const PS5_STOCK = '/api/read/v1/services/:service_id/option/ps5/stock';
      }
    }
  }
  /** 更新系API */
  export namespace Write {
    /** 契約者情報更新 */
    export const CONTRACT_INFO = '/api/write/v1/contract';
    /** 回線申込キャンセル */
    export const CONTRACT_ENTRY_CANCEL = '/api/write/v1/contract/entry-cancel';
    /** メールアドレス変更 */
    export const EMAIL = '/api/write/v1/contract/email';
    /** プロモーション情報更新 */
    export const PROMOTION_INFO = '/api/write/v1/promotion';
    /** 支払情報更新（クレジットカード） */
    export const CREDIT_CARD = '/api/write/v1/payment/credit-card';
    /** 支払情報更新（クレジットカード） 3Dセキュア認証 */
    export const NURO_CREDIT_CARD_V2 = '/api/write/v2/payment/nuro-credit-card';
    /** 支払情報変更URL（ソフトバンク請求）SMS送信 */
    export const SB_BILLING_SMS = '/api/write/v1/payment/sb-billing-sms';
    /** 支払情報変更URL（KDDI請求）SMS送信 */
    export const KDDI = '/api/write/v1/payment/kddi-billing-sms';
    /** 支払情報更新（NTT請求 SMS送信） */
    export const DOCOMO_SMS = '/api/write/v1/payment/ntt-billing-sms';
    /** 支払情報更新（NTT請求 確認コード検証） */
    export const DOCOMO_CONFIRM = '/api/write/v1/payment/ntt-billing-confirm';
    /** オプション情報更新 */
    export const OPTIONS_INFO = '/api/write/v1/option';
    /** U-NEXT情報更新 */
    export const U_NEXT_INFO = '/api/write/v1/unext-option-change';
    /** VoIPオプション情報更新 */
    export const VOIP_OPTION_INFO = '/api/write/v1/option/voip';
    /** VoIPオプション解約 */
    export const VOIP_OPTION_QUIT = '/api/write/v1/option/voip/quit';
    /** RVoIPオプション情報更新 */
    export const RVOIP_OPTION_INFO = '/api/write/v1/option/rvoip/change';
    /** Secomオプション申込 */
    export const SECOM_OPTION_ENTRY = '/api/write/v1/option/secom/entry';
    /** Secomオプション解約 */
    export const SECOM_OPTION_QUIT = '/api/write/v1/option/secom/quit';
    /** ブラビア家電リサイクル申込 */
    export const BRAVIA_RECYCLE_ENTRY = '/api/write/v1/option/bravia-recycle-entry';
    /** ひかりTV解約 */
    export const HIKARI_TV_OPTION_QUIT = '/api/write/v1/option/hikaritv/quit';
    /** ホワイトコール24申込書請求 */
    export const WC24_FORM_DEMAND = '/api/write/v1/option/voip/wc24/form-demand';
    /** Web明細ログインID/パスワード再発行 */
    export const WEB_DETAIL_REISSUE = '/api/write/v1/option/voip/web-detail-reissue';
    /** 確認コード送信 */
    export const CONFIRMATION_NUMBER = '/api/write/v1/confirmation-number';
    /** 確認コード検証 */
    export const CONFIRMATION_NUMBER_VERIFICATION =
      '/api/write/v1/confirmation-number/verification';
    /** キャッシュバック口座登録 */
    export const CASHBACK_REGISTER = '/api/write/v1/regist-cashback-account';
    /** ID/PWD変更 */
    export const ID_PASSWORD_CHANGE = '/api/write/v1/user/id-password';
    /** 紹介者トークン発行 */
    export const INTRODUCE_CREATE = '/api/write/v1/introduceCreate';
    /** 移転トークン発行 */
    export const MOVE_TOKEN_CREATE = '/api/write/v1/moveTokenCreate';
    /** 解約受付 */
    export const QUIT = '/api/write/v1/quit';
    /** 解約キャンセル */
    export const QUIT_CANCEL = '/api/write/v1/quit-cancel';
    /** 請求先住所情報更新 */
    export const BILLING_ADDRESS_INFO = '/api/write/v1/billing-address-info';
    /** NUROでんき契約プラン情報変更 */
    export const NURO_DENKI_PLAN_CHANGE = '/api/write/v1/option/nurodenki_plan_change';
    /** NUROでんき契約プラン情報取得 */
    export const NURO_DENKI_PLAN_INFO = '/api/write/v1/option/nurodenki_plan_info';
    /** プレゼントキャンペーン情報登録 */
    export const PRESENT_CAMPAIGN_ACCEPT = '/api/write/v1/campaign/present-accept';
    /** 10Gアップグレード新規申込 */
    export const UPGRADE_COMPLETED = '/api/write/v1/g10UpgradeEntry';
    /** 10Gアップグレード新規申込 （マンション用） */
    export const UPGRADE_COMPLETED_FOR_MANSION = '/api/write/v1/g10upgEntryMansion';
    /** 配送集荷希望日変更 */
    export const CHANGE_PREFERED_DATE = '/api/write/v1/change-prefered-date';
    /** ひかりTV契約情報変更 */
    export const HIKARI_OPTION_CHANGE = '/api/write/v1/services/:service_id/option/hikaritv';

    // V2
    /** メールアドレス変更 */
    export const EMAIL_V2 = '/api/write/v2/services/:service_id/contract/email';
    /** プロモーション情報更新 */
    export const PROMOTION_V2 = '/api/write/v2/services/:service_id/contract/promotion';
    /** 契約者情報更新V2 */
    export const CONTRACT_INFO_V2 = '/api/write/v2/services/:service_id/contract';
    /** 支払情報更新（クレジットカード） */
    export const CREDIT_CARD_V2 = '/api/write/v2/services/:service_id/payment/credit-card';
    export const CREDIT_CARD_V3 = '/api/write/v3/services/:service_id/payment/credit-card';
    /** ID/PWD変更 */
    export const ID_PASSWORD_CHANGE_V2 = '/api/write/v2/services/:service_id/user/id-password';

    /** 3Dセキュア認証 */
    export const MOBILE_CHECK_TOKEN = '/api/read/v1/mobile/:service_id/check-token';
    export const MOBILE_SECURE_ENCRYPT = '/api/write/v1/mobile/:service_id/secure-encrypt';
    export const MOBILE_SECURE_DECRYPT = '/api/write/v1/mobile/:service_id/secure-decrypt';
    export const CHECK_TOKEN = '/api/read/v1/check-token/';
    export const SECURE_ENCRYPT = '/api/write/v1/secure-encrypt/';
    export const SECURE_DECRYPT = '/api/write/v1/secure-decrypt';
  }
}

/** アプリ全体で使う画面表示・業務判定用定数。 */
export namespace Constants {
  export namespace ServiceType {
    export const HIKARI = 'fixed';
    export const MOBILE = 'mobile';
  }

  export namespace Poring {
    export const REFETCH_INTERVAL = 1000;
    export const REFETCH_COUNT = 60;
  }

  export namespace AreaJudgeResult {
    export const OK = 'ok';
    export const SOME_AREA = 'some_area';
    export const NG = 'ng';
  }

  export namespace Service {
    export namespace Category {
      export const GS10HOME = 'gs10home';
      export const GS20HOME = 'gs20home';
      export const HIKARI_TV = 'hikaritv';
    }
  }
  export namespace Address {
    export namespace Services {
      export namespace StateSummary {
        export const PROVIDING = 'providing';
        export const PROVIDING_PARTIALLY = 'providing_partially';
        export const ACCEPTING = 'accepting';
        export const ACCEPTING_PARTIALLY = 'accepting_partially';
        export const SCHEDULED = 'scheduled';
        export const SCHEDULED_PARTIALLY = 'scheduled_partially';
        export const NOT_PROVIDING = 'not_providing';
      }

      export namespace Details {
        export namespace State {
          export const PROVIDING = 'providing';
          export const ACCEPTING = 'accepting';
          export const SCHEDULED = 'scheduled';
          export const NOT_PROVIDING = 'not_providing';
        }
      }
    }
  }

  export namespace HouseType {
    export const KODATE = 'single';
    export const MANSION = 'multiple';
  }

  export namespace PasswordReset {
    export namespace AuthenticationMethod {
      export const MAIL = 'one_time_pwd_mail';
      export const SMS = 'one_time_pwd_sms';
    }
  }

  export namespace Option {
    export namespace Category {
      export const DISCOUNT = 'discount';
      export const LIFE_SUPPORT = 'life_support';
      export const IoT = 'IoT';
    }

    export namespace Name {
      export const VOIP = 'NURO 光 でんわ';
      export const RVOIP = 'NURO 光 でんわ One Type';
      export const HIKARI_TV = 'ひかり TV for NURO';
      export const NURO_SAFE = 'NURO 光 Safe';
      export const U_NEXT = 'U-NEXT for NURO';
      export const KURASHINO_KENKO = 'Ｓｏ‐ｎｅｔ　くらしの健康';
      export const KURASHINO_SODAN = 'Ｓｏ‐ｎｅｔ　くらしの相談';
      export const SUMAINO_KAKETSUKE = 'ＮＵＲＯ　住まいのかけつけ';
      export const KURASHINO_OMAMORI_WIDE = 'くらしのお守りワイド';
      export const NURO_DENKI = 'ＮＵＲＯでんき';
      export const MATOMETE_DENKI = 'まとめて でんき';
    }

    export namespace HikariTvPlan {
      export const BASIC_CONTRACT = '01';
      export const VALUE = '02';
      export const RECOMMENDED_TV = '03';
      export const PERSONAL_VIDEO_CHANNEL = '11';
      export const PERSONAL_CHANNEL = '12';
      export const BASIC = '13';
      export const PERSONAL_VIDEO_CHANNEL_DISCOUNT = '14';
      export const PERSONAL_CHANNEL_DISCOUNT = '15';
    }
  }

  export namespace Promotion {
    export namespace Type {
      // メール
      export const UP_SELL_MAIL = 'UP_SELL_MAIL'; // サービスに関するご案内（メール）
      export const BENEFIT_MAIL = 'BENEFIT_MAIL'; // 優待特典に関するご案内（メール）
      export const CROSS_SELL_MAIL = 'CROSS_SELL_MAIL'; // 自社および提携会社の製品・サービスに関するご案内（メール）
      // SMS NURO 光のみ
      export const UP_SELL_SMS = 'UP_SELL_SMS'; // サービスに関するご案内（SMS）
      export const BENEFIT_SMS = 'BENEFIT_SMS'; // 優待特典に関するご案内（SMS）
      export const CROSS_SELL_SMS = 'CROSS_SELL_SMS'; // 自社および提携会社の製品・サービスに関するご案内（SMS）
      // 郵送 NUROモバイルのみ
      export const UP_SELL_POST = 'UP_SELL_POST'; // サービスに関するご案内（POST）
      export const BENEFIT_POST = 'BENEFIT_POST'; // 優待特典に関するご案内（POST）
      export const CROSS_SELL_POST = 'CROSS_SELL_POST'; // 自社および提携会社の製品・サービスに関するご案内（SMS）
    }
  }

  export namespace PrivateOrganizationInfoReportList {
    export const MAX = 3;
  }

  export namespace Str {
    export const ZENKAKU_HYPHEN = '\uff0d';
    export const ZENKAKU_SPACE = '\u3000';
  }

  export namespace ValidationMessage {
    export const REQUIRED_INPUT = '必須項目が未入力です';
    export const REQUIRED_SELECT = '選択してください';
    export const NUMERIC = '数字で入力してください';
    export const ALPHANUMERIC = '英数字を入力してください';
    export const ZENKAKU = '全角で入力してください';
    export const ZENKAKU_KANA = '全角カタカナで入力してください';
    export const MAIL = '正しいメールアドレスを入力してください';
    export const MAIL_CONFIRM_ERROR = 'メールアドレスが異なります';
    export const PHONE = '電話番号は10~11桁の半角数字で入力してください';
    export const LAND_PHONE = '電話番号は10桁の半角数字で入力してください';
    export const ZIP_CODE = '正しい郵便番号を入力してください';
    export const CREDIT_CARD_NUMBER = '不正なクレジットカード番号です';
    export const CREDIT_CARD_SECURITY_CODE = '不正なセキュリティコードです';
    export const CREDIT_CARD_EXPIRATION_DATE = '不正な有効期限です';
    export const NEED_PARENTAL_CONCENT =
      '大変申し訳ございませんが、18歳未満のお客さまの入会は承っておりません。';
  }

  export namespace ErrorDialogMessage {
    export const DEFAULT =
      'システムエラーが発生いたしました。\n大変ご不便をお掛けいたしますが、しばらく経ってから再度お試しください。';
    export const OPTION_CHANGE = '現在、お申込みを受け付けられない状態です。';
    export const MAINTENANCE =
      '現在、システムのメンテナンス中です。\nしばらく経ってから操作してください。';
    export const MAINTENANCE_CREDITCARD =
      '現在、クレジットカード認証システムのメンテナンス中です。\nしばらく経ってから操作してください。';
    export const CASHBACK_COMPLETE = 'すでにキャッシュバックの入金手続が行われています';
    export const CASHBACK_EXCLUDE = 'キャッシュバック対象外です。';
    export const SIM_STOP_NOT_ONE_TARGET =
      '利用停止に失敗しました。<br/><a href="https://support.sonynetwork.co.jp/faqsupport/nuromobile/web/knowledge2743.html" target="blank" rel="noreferrer">窓口へお問い合わせください</a>';
    export const SIM_RESTART_NOT_ONE_TARGET =
      '利用再開に失敗しました。<br/><a href="https://support.sonynetwork.co.jp/faqsupport/nuromobile/web/knowledge2743.html" target="blank" rel="noreferrer">窓口へお問い合わせください</a>';
  }

  export namespace PaymentMethod {
    export const BANK_TRANSFER: CodeAndName = { code: '10', name: '銀行振込' };
    export const BANK_TRANSFER_BEFORE_ACCOUNT_TRANSFER: CodeAndName = {
      code: '11',
      name: '口座振替前銀行振込',
      nameShort: '銀行振込',
    };
    export const ACCOUNT_TRANSFER: CodeAndName = { code: '20', name: '自動口座振替' };
    export const CREDIT_CARD: CodeAndName = { code: '30', name: 'クレジットカード' };
    export const CONVENIENCE_STORE: CodeAndName = {
      code: '40',
      name: 'コンビニ払い',
      nameShort: 'コンビニ',
    };
    export const CONVENIENCE_STORE_BEFORE_ACCOUNT_TRANSFER: CodeAndName = {
      code: '41',
      name: '口座振替前コンビニ',
      nameShort: 'コンビニ',
    };
    export const ISP_RESELLER: CodeAndName = {
      code: '50',
      name: 'ISP・リセラー請求',
      nameShort: 'ISP・リセラー請求',
    };
    export const NTT_TEL: CodeAndName = {
      code: '60',
      name: 'NTT請求（電話料金合算）',
      nameShort: 'NTTドコモ合算請求',
    };
    export const SB_TEL: CodeAndName = {
      code: '70',
      name: 'ソフトバンク請求（電話料金合算）',
      nameShort: 'ソフトバンクまとめて支払い',
    };
    export const AU: CodeAndName = {
      code: '80',
      name: 'au PAY（auかんたん決済）',
      nameShort: 'au PAY（auかんたん決済）',
    };
  }

  export const NOT_PAYMENT: CodeAndName = { code: '90', name: '請求しない' };
  export const PENDING: CodeAndName = { code: '99', name: '未確定' };
  export namespace OptionStatus {
    export const NONE = 'NONE';
    export const ENTRY = 'ENTR';
    export const SERVICE = 'SRVC';
    export const CANCEL = 'CNCL';
    export const QUIT = 'QUIT';
    export const QUIT_WITHOUT = 'QTWT';
  }
  export namespace OptionStatusName {
    export const NONE = '未申込';
    export const ENTRY = '申込中';
    export const SERVICE = '利用中';
    export const CANCEL = 'キャンセル';
    export const QUIT = '解約済';
    export const QUIT_WITHOUT = '解約中';
  }
  export namespace VoipOptionStatus {
    export const NONE = '未申込';
    export const ENTRY = '申込中';
    export const SERVICE = '利用中';
    export const CANCEL = 'キャンセル';
    export const QUIT = '解約完了';
    export const QUIT_WITHOUT = '解約中';
    export const QUIT_REQUESTED = '解約手続き中';
  }

  export namespace RvoipOptionStatus {
    export const NONE = '未申込';
    export const ENTRY_ACCEPT = '申込中'; // 申込受付
    export const ENTRY_NG_SUPPORTED = '申込中'; // NG対応中
    export const ENTRY_OPENING_REQUESTED = '申込中'; // 開通依頼済み
    export const SERVICE = '利用中'; // using
    export const QUIT_QUITTIG = '解約中'; // quitting
    export const QUIT_REQUESTED = '解約中'; // 解約依頼済み
    export const QUIT_FINISHED = '解約完了'; // 完了
    export const CANCEL_CANCELING = 'キャンセル'; // キャンセル中
    export const CANCEL = 'キャンセル';
  }

  export namespace ApiType {
    export const API_GET = 'get';
    export const OPTION_CHANGE = 'optionChange';
    export const API_POST = 'post';
  }

  export namespace VoipOptionServicePack {
    export const SERVICE_PACK_NONE = '00';
    export const SERVICE_PACK_1 = '01';
    export const SERVICE_PACK_2 = '02';
    export const SERVICE_PACK_3 = '03';
    export const SERVICE_PACK_4 = '04';
    export const SERVICE_PACK_5 = '05';
  }

  export namespace VoipOptionServicePackClassType {
    export const VOIP_PACK1: string = '01';
    export const VOIP_PACK2: string = '02';
    export const VOIP_PACK3: string = '03';
    export const VOIP_PACK4: string = '04';
    export const VOIP_PACK_BASIC: string = '05';
  }

  export namespace VoipOptionClassType {
    export const VOIP_NUMBER_DISPLAY: string = 'numberDisplay';
    export const VOIP_NUMBER_INFO: string = 'numberRequest';
    export const VOIP_CATCH: string = 'catchPhone';
    export const VOIP_TRANSFER: string = 'voiceWarp';
    export const VOIP_BLOCK_CALL: string = 'stopNuisanceCall';
    export const VOIP_SENDER_NUMBER_INFO: string = 'numberNotice';
  }

  // 電話サービス提供事業者リスト
  export namespace VoipList {
    export const NTT: CodeAndName = {
      code: '00',
      name: 'NTT加入電話',
    };
    export const NTT_LIGHT: CodeAndName = { code: '01', name: 'NTT加入電話ライトプラン' };
    export const SOFTBANK: CodeAndName = {
      code: '06',
      name: 'おとくライン / ホワイト光電話（ソフトバンク）',
    };
    export const HIKARI: CodeAndName = {
      code: '31',
      name: 'ひかり電話（NTT）※各社光コラボご利用中の方はこちら',
    };
    export const AU_CABLE_JCOM: CodeAndName = {
      code: '36',
      name: 'auひかり電話 / ケーブルプラス電話（KDDI）',
    };
    export const JCOM_PHONE_PLUS: CodeAndName = { code: '38', name: 'J:COM　PHONEプラス' };
    export const FUSION: CodeAndName = { code: '39', name: 'FUSION / 楽天モバイル' };
    export const COMMUFA: CodeAndName = { code: '73', name: 'コミュファ光電話（CTC）' };
    export const EO: CodeAndName = {
      code: '75',
      name: 'eo光電話（オプテージ ※旧ケイ・オプティコム）',
    };
    export const MEGAEGG: CodeAndName = {
      code: '76',
      name: 'メガ・エッグ光電話（エネコム）',
    };
    export const BBIQ: CodeAndName = { code: '78', name: 'BBIQ光電話（QTnet）' };
    export const HOME: CodeAndName = { code: '90', name: 'homeでんわ（NTTドコモビジネス）' };
    export const OTHERS: CodeAndName = { code: '99', name: 'その他' };
  }

  // VoIP申込
  export namespace VoipEnter {
    export namespace Message {
      export const PACK1 =
        '番号表示、番号通知リクエスト、キャッチ電話、着信お断り通話、着信転送を、お申込みの場合は、パック１を選択してください。';
      export const PACK2 =
        'キャッチ電話、着信お断り通話、着信転送を、お申込みの場合は、パック２を選択してください。';
      export const PACK3 =
        '番号表示、番号通知リクエスト、キャッチ電話、着信お断り通話を、お申込みの場合は、パック３を選択してください。';
      export const PACK4 =
        'キャッチ電話、着信お断り通話を、お申込みの場合は、パック４を選択してください。';
      export const PACK_BASIC =
        '番号表示、番号通知リクエストを、お申込みの場合は、ベーシックパックを選択してください。';
      export const NOT_AVAILABLE_NUMBER_PORTABILITY = '番号ポータビリティは選択できません。';
      export const NG_STATUS = '現在、お申し込みを受け付けられない状態です。';
      export const CHANGE_DUPLICATE =
        '現在、付加サービスの変更の手続き中のため、お申込みいただけません。手続き完了までしばらくお待ちください。'; // F30W0006
      export const CHANGE_NG =
        '付加サービスの変更は、NURO 光でんわが利用中でない場合、お申込みいただけません。'; // F30W0007
      export const CHANGE_NG_ONE_TYPE =
        '付加サービスの変更は、NURO 光 でんわ One Type が利用中でない場合、お申込みいただけません。';
      export const CHANGE_FILE_NG = '付加サービスの変更処理中にエラーが発生しました。'; // F30W0008
      export const RECHANGE_NG =
        '変更を受け付けられないステータスか変更受付中のため、変更処理ができません。';
    }
  }

  // VoIP申込確認
  export namespace VoipEnterConfirm {
    export namespace Message {
      export const NUMBER_PORTABILITY_ERROR =
        '該当地域は番号ポータビリティの提供エリア外のため、お申込みいただけません。'; // F30W0003
      export const VOIP_STATUS_ERROR =
        '既にNURO 光でんわの申込を受け付けています。手続き完了までしばらくお待ちください。'; // F30W0004
    }
  }

  export namespace VoipSource0abjType {
    export const NEW_ISSUE = 0;
    export const NUMBER_PORTABILITY = 1;
  }

  // WC24
  export namespace WC24 {
    export namespace Message {
      export const SUCCESS = 'ホワイトコール24申込書の送付依頼を受け付けました。';
      export const VALIDATION_ERROR = '当日の申込書請求が既に存在するため請求できませんでした。';
      export const SYSTEM_ERROR = 'エラーが発生したため請求できませんでした。';
    }
  }

  // 回線解約受付エラー
  export namespace QuitEnter {
    export namespace Message {
      export const SYSTEM_ERROR =
        'エラーが発生したためご解約の受付ができませんでした。NURO 光サポート窓口までお問い合わせください。';
      export const NTT_SYSTEM_ERROR = '承諾番号の払い出しが失敗しました。';
      export const NTT_ERROR_DETAIL_URL =
        'https://support.nuro.jp/faqsupport/nuro/web/knowledge10911.html';
    }
  }

  // 回線申込キャンセル受付エラー
  export namespace EntryCancel {
    export namespace Message {
      export const NOT_ALLOWED =
        'キャンセル受付可能な期間を過ぎているためキャンセルの受付ができませんでした。\nNURO 光サポート窓口までお問い合わせください。';
    }
  }

  // 回線解約 NURO 光 でんわ番号ポータビリティ有無
  export namespace CancelInfoNumberPortability {
    export const YES: CodeAndName = { code: '1', name: '引き継ぐ' }; // 番号ポータビリティ有
    export const NO: CodeAndName = { code: '2', name: '引き継がず利用終了する' }; // 番号ポータビリティ無
  }

  // 回線解約 ONU/TA回収住所
  export namespace CancelInfoOnuAddress {
    export const INSTALLATION: CodeAndName = { code: '1', name: '設置先住所から返却する' };
    export const PICKUP: CodeAndName = { code: '2', name: '返却元住所を入力する' };
  }

  // 回線解約 PS5月額オプション解約方法
  export namespace CancelInfoPS5 {
    export const BUYING: CodeAndName = { code: '1', name: '「機器買取」解約手続きをする' };
    export const PICKUP: CodeAndName = { code: '2', name: '「機器回収」解約手続きをする' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用する' };
  }

  // 解約キャンセル PS5月額オプション解約方法
  export namespace QuitCancelInfoPS5 {
    export const BUYING: CodeAndName = { code: '2', name: '機器買取' };
    export const PICKUP: CodeAndName = { code: '1', name: '機器回収' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用' };
  }

  // 回線解約 PS5for NURO解約方法
  export namespace CancelInfoPS5Nuro {
    export const BUYING: CodeAndName = { code: '1', name: '「機器買取」解約手続きをする' };
    export const PICKUP: CodeAndName = { code: '2', name: '「機器回収」解約手続きをする' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用する' };
  }

  // 解約キャンセル PS5for NURO解約方法
  export namespace QuitCancelInfoPS5Nuro {
    export const BUYING: CodeAndName = { code: '2', name: '機器買取' };
    export const PICKUP: CodeAndName = { code: '1', name: '機器回収' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用' };
  }

  // 回線解約 BRAVIA月額オプション解約方法
  export namespace CancelInfoBravia {
    export const BUYING: CodeAndName = { code: '1', name: '「機器買取」解約手続きをする' };
    export const PICKUP: CodeAndName = { code: '2', name: '「機器返却」解約手続きをする' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用する' };
  }

  // 解約キャンセル BRAVIA月額オプション解約方法
  export namespace QuitCancelInfoBravia {
    export const BUYING: CodeAndName = { code: '2', name: '機器買取' };
    export const PICKUP: CodeAndName = { code: '1', name: '機器返却' };
    export const CONTINUE: CodeAndName = { code: '3', name: 'オプションのみ継続利用' };
  }

  // 回線解約 解約理由
  export namespace CancelInfoReason {
    export const REASON21: CodeAndName = {
      code: '21',
      name: '引越先の地域・建物でNURO 光が利用不可だから',
    };
    export const REASON03: CodeAndName = {
      code: '03',
      name: '料金が高かったから',
    };
    export const REASON22: CodeAndName = {
      code: '22',
      name: '他社の携帯セット割へ移行するから',
    };
    export const REASON23: CodeAndName = {
      code: '23',
      name: '他社のキャンペーンが魅力的だから',
    };
    export const REASON24: CodeAndName = {
      code: '24',
      name: '長期利用のメリットを感じないから',
    };
    export const REASON07: CodeAndName = {
      code: '07',
      name: 'サポートに不満だから',
    };
    export const REASON01: CodeAndName = {
      code: '01',
      name: '回線速度に不満だから',
    };
    // 画面に表示しない
    // export const REASON25: CodeAndName = {
    //   code: '25',
    //   name: 'NURO 光の料金変更',
    // };
    export const REASON99: CodeAndName = {
      code: '99',
      name: 'その他',
    };
  }

  export namespace OptionOrderType {
    export const SIMPLE_ENTRY = 1;
    export const SIMPLE_ENTRY_CANCEL = 2;
    export const SIMPLE_QUIT = 3;
    export const SIMPLE_QUIT_CANCEL = 4;
    export const CONTENT_CHANGE = 5;
    export const SAME_TIME_ENTRY = 6;
  }

  export namespace OptionCode {
    // 追加・変更がある場合はoption.jsonも書き換える
    export const NURO_HIKARI_DENWA = 'VOIP';
    export const NURO_HIKARI_DENWA_ONE_TYPE = 'RVOIP';
    export const U_NEXT_WEEKLY = 'MO100N';
    export const U_NEXT_MONTHLY = 'MO101N';
    export const HIKARI_TV = 'HIKARITV';
    export const KASPERSKY = 'MO200N';
    export const TSUNAGARU_ASSURANCE = 'MO201N';
    export const KURASHINO_OMAMORI = 'MO202N';
    export const NURO_REMOTE_SUPPORT_MANSION = 'MO203N';
    export const ANSHIN_PACK_MANSION = 'MO204N';
    export const NURO_SUMAINO_KAKETSUKE_MANSION = 'MO205N';
    export const KURASHINO_KENKO_MANSION = 'MO206N';
    export const KURASHINO_SODAN_MANSION = 'MO207N';
    export const KURASHINO_BENRI_PACK = 'MO208N';
    export const KASPERSKY_STANDARD = 'MO209N';
    export const NURO_MARUGOTO_SUPPORT = 'MO210N';
    export const NURO_REMOTE_SUPPORT_HIGHEND = 'MO211N';
    export const VALED_LIFE = 'MO212N';
    export const KURASHINO_SODAN_HIGHEND = 'MO213N';
    export const KURASHINO_KENKO_HIGHEND = 'MO214N';
    export const NURO_SUMAINO_KAKETSUKE_HIGHEND = 'MO215N';
    export const HIKARI_TV_1 = 'MO216N';
    export const HIKARI_TV_2 = 'MO217N';
    export const RAKURAKU_BACKUP = 'MO232N';
    export const ITSUDEMO_KAKETSUKE = 'MO233N';
    export const ANSHIN_REPAIR = 'MO234N';
    export const OMAMORI_PACK_MANSION = 'MO235N';
    export const CHO_HODAI = 'MO237N';
    export const KURASHINO_OMAMORI_WIDE = 'MO238N';
    export const SEIKATSU_BENRI_PACK = 'MO239N';
    export const TOKUTOKU_DELIKITCH = 'MO256N';
    export const OSAIFU_SUPPORT = 'MO257N';
    export const SEIKATSU_OTASUKE_PACK = 'MO258N';
    export const KIKIHOSHO = 'MO259N';
    export const LIFE_SUPPORT_PACK = 'MO260N';
    export const NURO_DENKI = 'MO261N';
    export const MATOMETE_DENKI = 'MO262N';
    export const MIZUMORE_CHECKER = 'MO263N';
    export const NURO_GAS = 'MO264N';
    export const AMUE_LINK_ALL = 'MO265N';
    export const AMUE_LINK_INSTALLMENT = 'MO266N';
    export const MATOMETE_GAS = 'MO267N';
    export const SEITON_HOZON = 'MO268N';
    export const SMART_SET = 'MO269N';
    export const MCAFEE_MDS_FREE = 'MO270N';
    export const MCAFEE_MDS_PAID = 'MO271N';
    export const MCAFEE_OPS = 'MO272N';
    export const SMART_LOCK_SET = 'MO332N';
    export const SMART_CAMERA_SET = 'MO333N';
    export const VALED_LIFE_CONCIERGE = 'MO338N';
    export const NURO_SMART_HOME_START = 'MO339N';
    export const NURO_SMART_LIFE = 'MO340N';
    export const NURO_SMART_LIFE_FREE = 'MO368N';
    export const PS5 = 'MO341N';
    export const PS5_DIGITAL_EDITION = 'MO342N';
    export const PS5_NURO = 'MO362N';
    export const PS5_DE_NURO = 'MO363N';
    export const NURO_HIKARI_SAFE = 'MO343N';
    export const NURO_HIKARI_SAFE_STANDARD = 'MO344N';
    export const NURO_SAKUTTO_SUPPORT = 'MO345N';
    export const TSUNAGARU_MESH_WIFI = 'MO352N';
    export const BRAVIA = 'MO358N';
    export const NURO_ENTRY_PACK = 'MO357N';
    export const HANDS_UP = 'MM101N';
    // PlayStation(R)5 for NURO （A）
    export const PS5_FOR_NURO_A = 'MO369N';
    // PlayStation(R)5 デジタル・エディション for NURO （A）
    export const PS5_DE_FOR_NURO_A = 'MO370N';
    // PlayStation(R)5 デジタル・エディション 日本語専用 for NURO
    export const PS5_FOR_NURO_JPN = 'MO373N';
  }

  export namespace Amuelink {
    export const AmuelinkAccept = 'amuelink';
  }

  export namespace AmuelinkStatus {
    export const ENTRY = 'ENTR';
    export const SERVICE = 'SRVC';
    export const CANCEL = 'CNCL';
    export const QUIT = 'QUIT';
    export const QUIT_WITHOUT = 'QTWT';
  }
  export namespace SecomStatus {
    export const EXAM = 'EXAM';
    export const SERVICE = 'SRVC';
    export const CANCEL = 'CNCL';
    export const QUIT = 'QUIT';
  }
  export namespace Unext {
    export namespace UnextOrderType {
      export const SERVICE_ENTRY = 1; // 基本サービスプラン申込
      export const PROGRAM_GUIDE_CHANGE = 2; // プログラムガイド変更
    }
    export namespace UnextPlan {
      export const MONTHLY = 1; // 月額プラン
    }
    export namespace UnextOptionStatus {
      export const NONE = '未申込';
      export const ENTRY = '申込中';
      export const SERVICE = '利用中';
      export const CANCEL = 'キャンセル';
      export const QUIT = '解約完了';
      export const QUIT_WITHOUT = '解約受付済';
    }
  }

  export namespace Cashback {
    export namespace StatusCode {
      export const BEFORE_RECEIPT_PERIOD = '0';
      export const COMPLETE = '1';
      export const EXPIRES = '2';
      export const EXTINGUISHMENT_OF_RIGHTS = '3';
      export const ERROR = '4';
      export const DURING_PROCEDURE = '5';
      export const BEFORE_PROCEDURE = '6';
      export const ACCOUNT_HOLDER_ILLEGAL = '7';
    }

    export namespace StatusName {
      export const BEFORE_RECEIPT_PERIOD = '受取可能期間前';
      export const COMPLETE = '入金完了';
      export const EXPIRES = '期限切れ';
      export const EXTINGUISHMENT_OF_RIGHTS = '権利消滅';
      export const ERROR = '入金エラー';
      export const DURING_PROCEDURE = '手続き中';
      export const BEFORE_PROCEDURE = '手続き前';
      export const ACCOUNT_HOLDER_ILLEGAL = '口座情報誤り';
    }
  }

  export namespace SessionType {
    export const MAIL_CHANGE = 'MAIL_CHANGE';
  }

  export namespace PathList {
    export const NOT_LOGIN = [
      '/login',
      '/password_reset',
      '/entry_cancel',
      '/mobile/onestop/login',
      '/mobile/onestop/error',
    ];
  }

  /** お友達紹介クーポン */
  export namespace IntroducerRewards {
    export const URL = 'https://www.nuro.jp/hikari/friend_coupon/';
    export const SnsType = {
      TWITTER: 'http://twitter.com/share?text=',
      MAILTO: 'mailto:?body=',
      LINE: 'https://social-plugins.line.me/lineit/share?text=',
    } as const;
    export type SnsType = typeof SnsType[keyof typeof SnsType];
    export const SNS_TEXT = (type: SnsType, code: string) => {
      const TEXT = `＼わたしの #NURO光体験レポート ／\n\n（※NURO 光の通信速度やご利用の感想など、お友達への紹介コメントをぜひ添えてください）\n\n【お友達紹介クーポンコード】${code}\n`;
      return `${type}${encodeURIComponent(TEXT)}${URL}`;
    };
    export const PROMOTION_CODE_EXPIRED_ERROR = '！有効期限切れです';
  }

  /** So-net メール */
  export namespace SoNetMail {
    export const URL = 'https://webmail.so-net.ne.jp';
  }

  export namespace ContractEntryCancel {
    export const DESIRED_PICK_UP_TIME_LIST = [
      {
        code: '00',
        name: '指定なし',
      },
      {
        code: '08',
        name: '午前中',
      },
      {
        code: '14',
        name: '午後',
      },
    ];

    export const CANCEL_REASON_LIST = [
      { code: '024', name: '契約中回線の解約料が発生' },
      { code: '025', name: '住居備え付けの他社回線を利用' },
      { code: '001', name: '携帯電話セット割引で他社利用' },
      { code: '002', name: 'その他理由で他社利用' },
      { code: '009', name: '開通が遅い' },
      { code: '006', name: '工事に不承諾（オーナーまたはマンション管理組合）' },
      { code: '007', name: '説明が困難/面倒（オーナーまたはマンション管理組合）' },
      { code: '010', name: '工事内容に不満' },
      { code: '011', name: '1回目工事に不満' },
      { code: '012', name: '2回目工事に不満' },
      { code: '003', name: 'NURO 光で特典キャンペーンを変更したい' },
      { code: '004', name: 'NURO 光で料金・期間プラン変更したい' },
      { code: '026', name: 'NURO 光 for マンションへの申込' },
      { code: '027', name: '回線速度に不安' },
      { code: '013', name: 'サポートに不満' },
      { code: '008', name: '家族が反対' },
      { code: '005', name: '重複申込' },
      { code: '028', name: '引越・引越取り止め' },
      { code: '029', name: '契約情報誤り' },
      // 画面に表示しない
      // { code: '014', name: '長期進捗なし' },
      // { code: '015', name: '不備解消不可/コンタクト取れず' },
      // { code: '016', name: '工事不可' },
      // { code: '017', name: '申込覚え無し' },
      // { code: '018', name: '情報不備によるキャンセル再登録' },
      // { code: '019', name: '年齢制限' },
      // { code: '020', name: '虚偽の説明/強引な勧誘' },
      // { code: '021', name: '代理店トラブル' },
      // { code: '022', name: '提供エリア外' },
      // { code: '030', name: 'プラン変更勧奨（FM成約・戸建キャンセル）' },
      // { code: '031', name: '窓口オーダー誤投入' },
      // { code: '046', name: 'NURO 光の料金変更' },
      { code: '023', name: 'その他' },
    ];
  }

  /** 書面投函日情報 */
  export namespace DocumentsPostingInfo {
    /** 初期表示件数 */
    export const MAX = 3;
    /**
     * 物流案件区分
     * 以下を「違約金証明用紙」の名称で表示する。
     * 戸建違約金補填キャンペーン(上限 7 万)
     * 戸建違約金補填キャンペーン(上限なし)
     */
    export const LM_MATTER_TYPE = {
      /** WC24申込用紙 */
      WC24: '2106',
      /** ID/PW通知書 */
      IDPW: '2108',
      /**
       * 戸建違約金補填キャンペーン(上限7万)
       * 違約金証明用紙
       */
      LIMIT7: '2120',
      /** */
      /**
       * 戸建違約金補填キャンペーン(上限なし)
       * 違約金証明用紙
       */
      NO_LIMIT: '2121',
    } as const;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    export type LM_MATTER_TYPE = typeof LM_MATTER_TYPE[keyof typeof LM_MATTER_TYPE];
    /** 物流案件区分の名前 */
    export const LM_MATTER_NAME = {
      [LM_MATTER_TYPE.WC24]: 'WC24申込用紙',
      [LM_MATTER_TYPE.IDPW]: 'ID/PW通知書',
      [LM_MATTER_TYPE.LIMIT7]: '違約金証明用紙',
      [LM_MATTER_TYPE.NO_LIMIT]: '違約金証明用紙',
    } as const;

    /** 物流ステータス */
    export const LM_STATE = {
      /** 新規 */
      NEW: '20101',
      /** 発送待ち */
      WAIT: '20201',
      /** キャンセル */
      CANCEL: '20301',
      /** 完了 */
      COMPLETE: '20400',
      /** 発送済み */
      SHIPPED: '20401',
      /** 未発送(印刷指示内容不正) */
      ILLEGAL: '20402',
      /** 未発送(その他) */
      ETC: '20499',
    } as const;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    export type LM_STATE = typeof LM_STATE[keyof typeof LM_STATE];
  }

  /** アップグレード可否判定 */
  export namespace UpgradesearchAcceptanceJudgement {
    export const UPGRADE = '1';
    export const NOTUPGRADE = '0';
  }

  export namespace Upgrade {
    export const UPGRADEOK = 'upgrade_ok';
    export const NOTUPGRADENG = 'not_upgrade_ng';
  }

  /** 紐づけSTSの開通済みフラグ  */
  export namespace UpgradesearchSTS {
    export const STS = '1';
    export const NOTSTS = '0';
  }

  export namespace STS {
    export const STSOK = 'sts_ok';
    export const NOTSTSNG = 'not_sts_ng';
  }

  /** 紐づけSTSの紐づけSTS  */
  export namespace UpgradelinkstateSTS {
    export const link = '1';
    export const NOTlink = '0';
  }

  export namespace LINK {
    export const LINKOK = 'link_ok';
    export const LINKNG = 'link_ng';
  }

  /** アップグレード受付判定 */
  export namespace UpgradeResult {
    export const RESULTAPPLY = '0';
    export const RESULTAVAILABLE = '1';
  }

  export namespace Result {
    export const RESULTOK = 'result_ok';
    export const RESULTNG = 'result_ng';
  }

  export namespace SubSystemId {
    export const NURO = 'nuro';
    export const SONC = 'sonc';
  }

  export namespace DateOfSwitching {
    export const INVOICE = '202310';
  }

  export namespace ContractInfo {
    export namespace Gender {
      export const MALE = '男性';
      export const FEMALE = '女性';
      export const OTHER = 'その他';
    }
  }

  /** 契約サービス情報 */
  export namespace Service {
    export const FIXED = 'fixed';
    export const MOBILE = 'mobile';
  }

  export namespace MnpApplicationStatus {
    export const OPTION_UPDATE_PROCESSING = 'option_update_processing';
    export const SHIPPING = 'shipping';
    export const MNP_RESERVE_WAIT = 'mnp_move_in_reserve_wait';
    export const MNP_RESERVING = 'mnp_move_in_reserving';
  }
  export namespace MnpQuitApplicationStatus {
    export const ACCEPT = 'accept';
    export const WAIT_MNP_PORT_OUT_NUMBER = 'wait_mnp_port_out_number';
    export const WAIT_MNP_PORT_OUT = 'wait_mnp_port_out';
    export const END = 'end';
  }
  /** パスワード設定者 */
  export namespace PasswordSetter {
    export const USER = 'user';
    export const SYSTEM = 'system';
  }
  /** 料金プランコード */
  export namespace PlanCode {
    export const MANSION_TYPE_S = 'MC1012';
    export const MANTION_TYPE_L = 'MM013N';
    export const ONE_2G = 'MC1013';
  }

  /** 料金プランコードリスト(2ｇマンション) */
  export const PLAN_CODE_FOR_2G_MANSION = [
    'MC1012',
    'MM013N',
    'MM007N',
    'MM008N',
    'MM009N',
    'MM003N',
    'MM004N',
    'MM005N',
    'MM001N',
  ];

  /** マンション2ギガタイプSの料金プランコード */
  export const PLAN_CODE_FOR_2G_MANSION_TYPE_S = ['MC1012'];

  /** マンション10Gアップグレード先の料金プランコード */
  export const PLAN_CODE_FOR_10G_MANSION = ['MM162N', 'MM014N', 'MM010N', 'MM011N'];

  /** マンション10Gアップグレード プランコードと経路コードとキャンペーン企画セットコードの組み合わせ */
  export const Ms10GPlanRouteAndCampaign = [
    {
      planCode: 'MM014N',
      routeCode: '10UGD002',
      campaignPlanSetCode: 'K9751ZZZ',
    },
    {
      planCode: 'MM010N',
      routeCode: '09325F00',
      campaignPlanSetCode: '',
    },
    {
      planCode: 'MM011N',
      routeCode: '09425F00',
      campaignPlanSetCode: '',
    },
  ];

  /** 集荷・配送状況 */
  export namespace DeliCollInfo {
    export namespace Collection {
      export const COLLECTION_BUTTON = '返却予定日時を変更する';
      export const RECOLLECTION_BUTTON = '再集荷を申し込む';
      export const COLLECTION_TITLE = '返却予定日の変更';
      export const RECOLLECTION_TITLE = '再集荷希望日の申込';
      export const COLLECTION_DATE = '返却予定日';
      export const RECOLLECTION_DATE = '再集荷希望日';
      export const COLLECTION_TIME = '集荷希望時間帯';
      export const RECOLLECTION_TIME = '再集荷希望時間帯';
      export const COLLECTION_NOTES = '・返却予定日は4日後以降から選択可能です。';
      export const RECOLLECTION_NOTES = '・再集荷希望日は4日後以降から選択可能です。';
      export const COLLECTION_CHANGE_TYPE = '2';
      export const COLLECTION_TITLE_CONFIRM = '返却予定日の変更の確認';
      export const RECOLLECTION_TITLE_CONFIRM = '再集荷希望日の申込の確認';
    }
    export namespace Delivery {
      export const DELIVERY_BUTTON = '配送希望日時を変更する';
      export const REDELIVERY_BUTTON = '再配送を申し込む';
      export const DELIVERY_TITLE = '配送希望日の変更';
      export const REDELIVERY_TITLE = '再配送希望日の申込';
      export const DELIVERY_DATE = '配送希望日';
      export const REDELIVERY_DATE = '再配送希望日';
      export const DELIVERY_TIME = '配送希望時間帯';
      export const REDELIVERY_TIME = '再配送希望時間帯';
      export const DELIVERY_NOTES = '・配送希望日は3日後以降から選択可能です。';
      export const REDELIVERY_NOTES = '・再配送希望日は3日後以降から選択可能です。';
      export const DELIVERY_CHANGE_TYPE = '1';
      export const DELIVERY_TITLE_CONFIRM = '配送希望日の変更の確認';
      export const REDELIVERY_TITLE_CONFIRM = '再配送希望日の申込の確認';
    }
  }

  // 回線解約 BRAVIA月額オプション解約方法
  export namespace LineReuse {
    export const USE: CodeAndName = { code: '1', name: '利用する' };
    export const UNUSE: CodeAndName = { code: '0', name: '利用しない' };
  }
}
